import axios from "~/plugins/axios";

export default {
  paginate(
    page = 1,
    perPage = 15,
    filter = null,
    includes = [
      "search",
      "automation_action",
      "extending_searches",
      "email_user",
      "email_account",
      "email_template",
      "search_thumbnail",
      "html_email_template",
    ],
  ) {
    return axios.get("/web_api/v1/automation", {
      params: {
        page,
        perPage,
        ...filter,
        includes,
      },
    }).then((response) => response.data);
  },
  deactivate(automationId) {
    return axios.patch(`/web_api/v1/automation/${automationId}/deactivate`);
  },
  activate(automationId, interval) {
    return axios.patch(`/web_api/v1/automation/${automationId}/activate`, {
      run_interval: interval,
    });
  },
  paginateActive(
    page = 1,
    perPage = 15,
    includes = [
      "search",
      "automation_action",
      "extending_searches",
      "email_user",
      "email_account",
      "email_template",
      "search_thumbnail",
      "html_email_template",
    ],
  ) {
    return axios.get("/web_api/v1/automation/active", {
      params: {
        page,
        perPage,
        includes,
      },
    })
      .then((response) => response.data);
  },
  skipAutomations(automationIds) {
    return axios.post("/web_api/v1/automation/skip", {
      skipped_automations: automationIds,
    });
  },
  automationsUnskippedPendingConfirmation(includes = []) {
    return axios.get("/web_api/v1/automation/unskipped_pending_confirmation", {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
  store(automation) {
    return axios
      .post("/web_api/v1/automation", automation)
      .then((response) => response.data);
  },
  update(automation) {
    return axios
      .put(`/web_api/v1/automation/${automation.id}`, automation)
      .then((response) => response.data);
  },
  getById(automationId, includes = [
    "search",
    "automation_action",
    "extending_searches",
    "email_user",
    "email_account",
    "email_template",
    "html_email_template",
  ]) {
    return axios
      .get(`/web_api/v1/automation/${automationId}`, {
        params: {
          includes,
        },
      })
      .then((response) => response.data);
  },
  destroy(automationId) {
    return axios
      .delete(`/web_api/v1/automation/${automationId}`)
      .then((response) => response.data);
  },
  run(automationId) {
    return axios
      .post(`/web_api/v1/automation/${automationId}/run`)
      .then((response) => response.data);
  },
  searchDescriptionByAutomation(automationId) {
    return axios.get(`/web_api/v1/automation/${automationId}/search_descriptions`)
      .then((response) => response.data.data);
  },
  paginateSearchablesByAutomation(
    automationId,
    page,
    perPage,
    name,
    include = [
      "customer",
    ],
  ) {
    return axios
      .get(`/web_api/v1/automation/${automationId}/searchables`, {
        params: {
          page,
          perPage,
          include,
        },
      })
      .then((response) => response.data);
  },
  executeOneTimeDataEnrichmentAutomation(automation) {
    return axios
      .post(`/web_api/v1/automation/${automation.id}/run`)
      .then((response) => response.data);
  },
  getMainSearchableOptions() {
    return axios
      .get("/web_api/v1/automation/main_searchable_options")
      .then((response) => response.data);
  },
};
